module.exports = __webpack_public_path__ + "static/img/case3_3.png";